// ESM-Huelle um lib/scripts/pos/CLS_CCashbox.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
function CCashbox()
{
    this.Printer = new CPrinter();

    this.canBeOpen = false;
    this.showHourglass = true;
    this.callbackFunction = null;
    this.callbackParameter = null;
    this.defaultCountdown = 30;
    this.countdown = this.defaultCountdown;
    this.defaultHourGlassText = "CLOSE_CASHBOX";
    this.hourGlassText = this.defaultHourGlassText;
    this.msInterval = 4;
    this.alarm = POS.EnvProperties.CASHBOXALARM;
    this.iconsOn = false;
    this.printerOn = true;
    this.lastState = "close";
    this.printerstatus = true;

/*    if (POS.EnvProperties.CASHBOX == "YES")  // TODO: Remove for cross-platform compatibility
#        POS.timeout.register("POS.Cashbox.watchdog()", this.watchdog, this,
#            this.msInterval);*/
}

CCashbox.prototype.watchdog = function (me)
{

    if (POS.EnvProperties.CASHBOX == "NO") return;

    if (me.waiting)
        return;

    if (me.countdown > 0)
        me.countdown --;
    if (! me.printerstatus)
   // if (! me.Printer.getStatusFromFile())
    {
        if (! me.printerOn)
        {
            POS.blockedStatus = true;
            return;
        }
        me.printerOn = false;
        var text = POS.lang.getText("MESSAGES", "CONNECT_PRINTER");
        POS.hourGlass.show(text);
        return;
    }

    if (! me.printerOn)
    {
        POS.blockedStatus = false;
        POS.hourGlass.hide();
        me.printerOn = true;
    }

    if (me.isDrawerOpen())
    {
        if (me.lastState == "close")
        {
            me.registerDB("open");
            me.lastState = "open";
        }

        if (! me.iconsOn)
            me.activateCashboxIcons();
        if (me.canBeOpen)
        {
            POS.hourGlass.hide();

            if (me.countdown == 0 && POS.isPOSOpened)
                POS.sound.playFile(me.alarm);

	     if (POS.isPOSOpened){
		me.wait(me);
	     }

            return;
        }

        if (me.showHourglass)
        {
            var text = POS.lang.getText("MESSAGES", me.hourGlassText);
            POS.hourGlass.show(text, me, me.wait);
        }
        else
            me.wait(me);
    }
    else
    {
        if (me.lastState == "open")
        {
            me.registerDB("close");
            me.lastState = "close";
        }
        if (me.callbackFunction != null)
        {
            POS.timeout.register("checkDrawerCallback", me.callbackFunction,
                me.callbackParameter, 1, 1);
            me.callbackFunction = null;
            me.callbackParameter = null;
        }
        else if (POS.sessions.currentSession != 0)
        {
            var main = POS.sessions.getSessionComponent();
            if (typeof main.cmpBAR != "undefined" && main.cmpBAR.paymentType == "BAR")
                main.cmpBAR.doCancel();
        }
        if (me.iconsOn)
            me.hideCashboxIcons();

        me.resetCountdown();
    }
}

CCashbox.prototype.wait = function (me)
{
    me.waiting = true;
    POS.timeout.register("POS.Cashbox.checkDrawer()", POS.Cashbox.checkDrawer, me,
        me.msInterval, 1);
}

CCashbox.prototype.checkDrawer = function (me)
{
    if (me.countdown == 0 && POS.isPOSOpened ){
        POS.sound.playFile(me.alarm);
	//neu


	}

    if (!me.isDrawerOpen())
    {
        me.hideCashboxIcons();
        if (me.showHourglass)
            POS.hourGlass.hide();

        if (me.callbackFunction != null)
        {
            POS.timeout.register("checkDrawerCallback", me.callbackFunction,
                me.callbackParameter, 1, 1);
            me.callbackFunction = null;
            me.callbackParameter = null;
        }

        me.resetCountdown();
        me.registerDB("close");
        me.lastState = "close";
        me.waiting = false;
    }
    else
    {
        if (me.countdown > 0)
            me.countdown--;
        POS.timeout.register("POS.Cashbox.checkDrawer()", POS.Cashbox.checkDrawer, me,
            me.msInterval, 1);
    }
}

CCashbox.prototype.resetCountdown = function ()
{
    this.countdown = this.defaultCountdown;
}

CCashbox.prototype.isDrawerOpen = function ()
{

    if (POS.EnvProperties.CASHBOX == "NO") return false;

    var status = this.Printer.getStatus("printer");

    if ((status == false) || (status[1] == 0))
    {
        // this will happen if there was some problem communicating with the printer;
        // the best we can do is just return the last state saved and hope that the printer will work again soon.
        if (this.lastState == "close")
            return false
        else
            return true
    }

    if (POS.EnvProperties.CASHBOXFLAG == "+")
    {
        if (status[2] == 0)
            return true;
        else
            return false;
    }
    else if (POS.EnvProperties.CASHBOXFLAG == "-")
    {
        if (status[2] != 0)
            return true;
        else
            return false;
    }
}

CCashbox.prototype.openDrawer = function ()
{
    var me = POS.Cashbox;

    me.Printer.openDrawer();
    me.activateCashboxIcons();

    me.registerDB("open");
    me.lastState = "open";
}

CCashbox.prototype.activateCashboxIcons = function ()
{
    if (POS.EnvProperties.CASHBOX == "NO")  // TODO: Remove for cross-platform compatibility
        return;

    this.iconsOn = true;

    for (var j in POS.sessions.openSessions)
    {
        if (j != 0)
        {
            POS.sessions.openSessions[j].InfoIcons.highlightIcon("cashbox",
                POS.sessions.openSessions[j].UID);
        }
    }
}

CCashbox.prototype.hideCashboxIcons = function ()
{
    for (var j in POS.sessions.openSessions)
    {
        if (j != 0)
        {
            POS.sessions.openSessions[j].InfoIcons.hideIcon("cashbox");
        }
    }

    this.iconsOn = false;
}

CCashbox.prototype.registerDB = function (mode)
{

    /*privMan.enablePrivilege (privList);*/

    if (typeof POS.POSId == "undefined" || POS.POSId == null || POS.POSId == 0 || !POS.isPOSOpened)
        return;

    var d = new Date();
    var userId = POS.sessions.currentSession;

    if (userId != 0)
    {
        var session = POS.sessions.getSessionComponent();
        var userName = session.userProps["Name"];
        var userLogin = session.userProps["Login"];
    }
    else
    {
        userName = "";
        userLogin = 0;
    }

    switch(mode)
    {
        case "open":
            var entryType = "CBO";
            log.add(4, "Info", "Kassenlade auf", "");
            break;
        case "close":
            entryType = "CBC";
            log.add(4, "Info", "Kassenlade zu", "");
            break;
    }

    var sql = "INSERT INTO BON " +
        "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) " +
        "VALUES (-1, " + (d/1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
        userLogin + ", '" + userName + "', 0, '" + entryType + "', NULL, 0)";

    POS.SQLiteCon.execute(sql);
}

export { CCashbox };
